import React, { useState } from 'react'
import storageWalkImage from "../../assets/storage_walk.jpeg"
import storageWalkLogo from "../../logo/blue_and_orange_storage_walk_logo.png"
import { usePublicSiteBranding, usePublicSiteId } from '../../contexts/PublicSiteContext'

const Hero = () => {
  const branding = usePublicSiteBranding()
  const siteId = usePublicSiteId()
  const isDefault = siteId === 'default'
  const [showPopup, setShowPopup] = useState(false);

  const handleEmailClick = () => {
    setShowPopup(true);
  }

  const handleClosePopup = () => {
    setShowPopup(false);
  }

  const getBackgroundStyle = () => {
    if (branding.heroBackgroundImageSrc) {
      return {
        backgroundImage: `url(${branding.heroBackgroundImageSrc})`,
        height: '80vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    }
    if (isDefault) {
      return {
        backgroundImage: `url(${storageWalkImage})`,
        height: '80vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    }
    if (siteId === 'security-walk') {
      return {
        backgroundColor: '#0C447C',
        height: '80vh',
        backgroundImage:
          'radial-gradient(circle at 80% 40%, rgba(55,138,221,0.25) 0%, transparent 55%)',
      }
    }
    if (siteId === 'construction-walk') {
      return {
        backgroundColor: '#1B1916',
        height: '80vh',
        backgroundImage:
          'radial-gradient(circle at 80% 40%, rgba(47,90,60,0.3) 0%, rgba(196,163,90,0.15) 30%, transparent 60%)',
      }
    }
    return {
      backgroundImage: `url(${storageWalkImage})`,
      height: '80vh',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }
  }

  const backgroundImageStyle = getBackgroundStyle()

  const heroLogoSrc =
    branding.heroMarkLogoSrc ?? branding.markLogoSrc ?? storageWalkLogo
  const heroLogoUsesWideAsset = Boolean(branding.heroMarkLogoSrc)

  return (
    <div className="w-full mx-auto py-20 px-6 flex justify-center" style={backgroundImageStyle}>
      <div className="flex flex-col items-center mt-6 lg:mt-2 justify-center">
        <img
          src={heroLogoSrc}
          alt={branding.heroLogoAlt}
          width={heroLogoUsesWideAsset ? 280 : undefined}
          height={heroLogoUsesWideAsset ? 432 : undefined}
          className={
            heroLogoUsesWideAsset
              ? 'h-auto w-auto max-h-64 max-w-[min(100%,280px)] object-contain drop-shadow-lg'
              : 'xs:w-72 md:w-80 xs:h-48 md:h-56 lg:w-96 lg:h-64 object-contain'
          }
        />
        {siteId === 'construction-walk' ? (
          <div className="mt-6 text-center max-w-3xl px-4">
            <div className="text-secondary text-lg md:text-xl font-semibold tracking-[0.3em] mb-4">
              TIME · WALK · DOCUMENT · SYNC
            </div>
            <div className="text-white text-xl md:text-2xl lg:text-3xl font-bold leading-tight mb-4" style={{ fontFamily: "'Source Sans 3', sans-serif" }}>
              {branding.heroTagline}
            </div>
            {branding.heroSupportingLine && (
              <div className="text-primary-light text-sm md:text-base leading-relaxed" style={{ fontFamily: "'Source Sans 3', sans-serif" }}>
                {branding.heroSupportingLine}
              </div>
            )}
          </div>
        ) : (
          <div className="mt-6 text-center text-2xl md:text-3xl font-bold tracking-wide text-white">
            {siteId === 'security-walk' ? (
              <>
                <span className="block">Every round.</span>
                <span className="block text-secondary-light">Verified.</span>
              </>
            ) : (
              branding.heroTagline
            )}
          </div>
        )}
        <button onClick={handleEmailClick} className="bg-marketing-accent py-3 px-12 my-14 text-white font-bold rounded-md hover:opacity-95">
          Get Started Today
        </button>
      </div>
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" onClick={handleClosePopup}>
          <div className="bg-white p-6 rounded-md shadow-lg xs:w-3/4 md:w-1/2" onClick={(e) => e.stopPropagation()}>
              <p className="text-center">
                Email us at{' '}
                <a href={`mailto:${branding.pricingContactEmail}`} className="text-primary hover:underline">
                  {branding.pricingContactEmail}
                </a>{' '}
                for more information
              </p>
            </div>
        </div>
      )}
    </div>
  )
}

export default Hero
